if (!customElements.get('ctr-meet-scents')) {
  class CtrMeetScents extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.sectionId = this.dataset.sectionId;
      this.tabs = this.querySelectorAll('.ctr-meet-scents__tab');
      this.panels = this.querySelectorAll('.ctr-meet-scents__panel');
      this.dropdownToggle = this.querySelector('.ctr-meet-scents__dropdown-toggle');
      this.dropdownMenu = this.querySelector('.ctr-meet-scents__dropdown-menu');
      this.dropdownLabel = this.querySelector('[data-dropdown-label]');
      this.dropdownOptions = this.querySelectorAll('.ctr-meet-scents__dropdown-option');
      this.mobileQuery = window.matchMedia('(max-width: 749.98px)');

      this.bindEvents(signal);
      this.mobileQuery.addEventListener('change', () => this.handleBreakpointChange(), { signal });
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    bindEvents(signal) {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab.dataset.tabId, tab.textContent.trim()), { signal });
      });

      this.dropdownOptions.forEach((option) => {
        option.addEventListener(
          'click',
          () => {
            this.activateTab(option.dataset.tabId, option.textContent.trim());
            this.closeDropdown();
          },
          { signal }
        );
      });

      if (this.dropdownToggle) {
        this.dropdownToggle.addEventListener('click', () => this.toggleDropdown(), { signal });
      }

      document.addEventListener(
        'click',
        (event) => {
          if (!this.contains(event.target)) {
            this.closeDropdown();
          }
        },
        { signal }
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape') {
            this.closeDropdown();
          }
        },
        { signal }
      );

      document.addEventListener(
        'shopify:block:select',
        (event) => {
          if (!this.contains(event.target)) return;
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;

          const tab = this.querySelector('.ctr-meet-scents__tab[data-tab-id="' + blockId + '"]');
          const label = tab ? tab.textContent.trim() : '';
          this.activateTab(blockId, label);
        },
        { signal }
      );
    }

    activateTab(tabId, label) {
      if (!tabId) return;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabId === tabId;
        tab.classList.toggle('ctr-meet-scents__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.dropdownOptions.forEach((option) => {
        const isActive = option.dataset.tabId === tabId;
        option.classList.toggle('ctr-meet-scents__dropdown-option--active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (this.dropdownLabel && label) {
        this.dropdownLabel.textContent = label;
      }

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panelId === tabId;
        panel.classList.toggle('ctr-meet-scents__panel--active', isActive);
        panel.hidden = !isActive;
      });
    }

    toggleDropdown() {
      if (!this.dropdownMenu || !this.dropdownToggle) return;

      const isOpen = !this.dropdownMenu.hidden;
      this.dropdownMenu.hidden = isOpen;
      this.dropdownToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    closeDropdown() {
      if (!this.dropdownMenu || !this.dropdownToggle) return;

      this.dropdownMenu.hidden = true;
      this.dropdownToggle.setAttribute('aria-expanded', 'false');
    }

    handleBreakpointChange() {
      if (!this.mobileQuery.matches) {
        this.closeDropdown();
      }
    }
  }

  customElements.define('ctr-meet-scents', CtrMeetScents);
}
